export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="rounded-3xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20workspace%20scene%20with%20organized%20desk%20and%20soft%20textures%2C%20cream%20and%20sage%20green%20aesthetic%2C%20gentle%20morning%20light%20streaming%20through%20window%2C%20minimalist%20editorial%20photography%2C%20clean%20composition%2C%20peaceful%20productive%20atmosphere%2C%20slight%20film%20grain%20texture&width=1600&height=700&seq=cta-acbuy-2026&orientation=landscape"
            alt="Organized workspace with ACBuySpreadsheet system"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            Discover the{" "}
            <span className="italic font-light text-foreground-500">most efficient</span> way
            <br />
            to manage your{" "}
            <strong className="text-primary-600">ACBuy Spreadsheet</strong> workflow
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
            Start organizing, comparing, and optimizing your data with the
            structured system trusted by users worldwide. No complex setup —
            just results.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-block px-10 py-4 rounded-full bg-foreground-950 text-background-50 font-label text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Access Full System
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}